import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AppProvider } from "./context/AppContext";
import { Toaster } from "./components/ui/toaster";
import { Toaster as SonnerToaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import { SoldOutBanner } from "./components/SoldOutBanner";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Store from "./pages/Store";
import ProductDetail from "./pages/ProductDetail";
import WineConfigurator from "./pages/WineConfigurator";
import LabelDesigner from "./pages/LabelDesigner";
import HowItWorks from "./pages/HowItWorks";
import Producers from "./pages/Producers";
import Regions from "./pages/Regions";
import RegionDetail from "./pages/RegionDetail";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Contacts from "./pages/Contacts";
import AGB from "./pages/AGB";
import Datenschutz from "./pages/Datenschutz";
import Impressum from "./pages/Impressum";
import GrapeVarieties from "./pages/GrapeVarieties";
import Login from "./pages/Login";
import Account from "./pages/Account";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Admin from "./pages/Admin";
import LegacyRedirect from "./components/LegacyRedirect";
import { AuthProvider } from "./context/AuthContext";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    document.querySelectorAll("title[data-rh], meta[data-rh]").forEach((n) => n.remove());
  }, []);
  return (
    <div className="App">
      <HelmetProvider>
        <AppProvider>
          <AuthProvider>
          <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <SoldOutBanner />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/store" element={<Store />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/wine-configurator" element={<WineConfigurator />} />
              <Route path="/label-designer" element={<LabelDesigner />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/producers" element={<Producers />} />
              <Route path="/regions" element={<Regions />} />
              <Route path="/regions/:id" element={<RegionDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/agb" element={<AGB />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/grape-varieties" element={<GrapeVarieties />} />
              <Route path="/login" element={<Login />} />
              <Route path="/account" element={<Account />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<LegacyRedirect />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
          <SonnerToaster position="top-center" richColors />
        </BrowserRouter>
        </AuthProvider>
      </AppProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
